import React from 'react';

import { Link, LINK_SEVERITY } from '@tmapy/style-guide';
import { useSelector } from '@tmapy/redux';

export const Footer: React.FC<{}> = () => {
  const footer = useSelector((state) => state.edas.appData.data.config.footer);

  return (
    <footer className='sg-a-d-f sg-a-jc-fe sg-u-bt sg-a-py-2 sg-u-hsl-1 sg-u-type-xxs'>
      {footer.company && <span>{footer.company}</span>}
      {footer.email && footer.mailto && (
        <Link href={`mailto:${footer.mailto}`} severity={LINK_SEVERITY.COLORFUL}>
          {footer.email}
        </Link>
      )}
      <Link href='https://www.tmapy.cz' severity={LINK_SEVERITY.COLORFUL}>
        &copy; T-MAPY spol. s r.o.
      </Link>
    </footer>
  );
};
